/**=========================================================
 * Module: supergroup.js
 * SuperGroup Controller
 =========================================================*/
App.controller('SupergroupController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', '$filter', 'toaster', 'ngDialog',
    function ($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, $filter, toaster, ngDialog) {
      "use strict";

      $scope.type = 'supergroup';
      $scope.id = $state.params.filter;

      $scope.model = {};
      $scope.error = {};
      $scope.page = {
        title: $scope.id ? '' : 'labels.SUPERGROUPADDNEW',
        subTitle: ''
      };
      $scope.pop = function (type, title, text) {
        toaster.pop(type, title, text, 0, 'trustedHtml');
      };

      $scope.initialized = false;
      $scope.watchActivated = false;
      $scope.init = function () {

        $scope.linesTable = {
          fields: []
        }
        $scope.usersTable = {
          fields: []
        }
        $scope.groupsTable = {
          fields: []
        }


        if ($rootScope.user.id && ($scope.id != 'undefined')) {
          $scope.initialized = true;
          $scope.decimalSep = $rootScope.user.decimalSep;

          $scope.model = {}


          D.load('supergroup', $scope.id || '').then(function (response) {
            $scope.model = response;
            $scope.page.title = response.name;

            $scope.form = {
              title: !$scope.id ? 'labels.SUPERGROUPADDNEW' : 'labels.SUPERGROUPEDIT',
              status: '',
              type: 'supergroup',
              model: $scope.model,
              fields: [{
                available: !$scope.id,
                type: 'text',
                name: 'code',
                required: true
              }, {
                available: true,
                type: 'text',
                name: 'name',
                required: true
              }, {
                available: true,
                type: 'select',
                name: 'currency',
                data: [{
                    value: '',
                    label: '-'
                },{
                    value: 'EUR',
                    label: $filter('translate')('enums.currencyName.EUR') + ' - ' + $filter('translate')('enums.currencySymbol.EUR') 
                },{
                    value: 'USD',
                    label: $filter('translate')('enums.currencyName.USD') + ' - ' + $filter('translate')('enums.currencySymbol.USD') 
                },{
                    value: 'GBP',
                    label: $filter('translate')('enums.currencyName.GBP') + ' - ' + $filter('translate')('enums.currencySymbol.GBP') 
                }],
                valueField: 'value',
                labelField: 'label',
                required: true,
                placeholder: ' '
            }, {
              available: true,
              type: 'checkbox',
              name: 'groupWords'
            }, {
                available: true,
                type: 'submit',
                name: 'empty',
                value: 'fields.SUBMIT'
              }],
              validate: function () {
                var errors = [];
                for (var j = 0; j < this.fields.length; j++) {
                  var field = this.fields[j];
                  if (field.available && field.name == 'code') {
                    if ($('[name=code]').val().length != 3) {
                      errors.push({
                        field: field,
                        error: '3char'
                      });
                    }

                  }
                }


                if (errors.length) {
                  var errorMessages = "<ul>";
                  for (var i = 0; i < errors.length; i++) {
                    var e = errors[i];
                    errorMessages += "<li>" +
                      $filter('translate')('labels.VALIDATIONERROR' + e.error.toUpperCase(), {
                        name: $filter('translate')('fields.' + e.field.name.toUpperCase())
                      }) +
                      "</li>";
                  }
                  errorMessages += "</ul>";
                  $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                  return false;
                } else return true;
              },
              submit: function () {
                if (this.validate()) {
                  $scope.form.status = 'submitting';
                  D.save($scope.type, $scope.model).then(
                    function (response) {
                      $scope.form.status = 'submitted';
                      $scope.id = response.id;
                      $state.go('app.entity', {
                        action: 'edit',
                        type: 'supergroup',
                        filter: $scope.id
                      });
                    }
                    
                  ).catch(function (response) {
                      $scope.form.status = 'error';
                    });
                }
              }
            };

            D.query('group', 'supergroup=' + $scope.id).then(function (response) {
              $scope.groups = response;

              $scope.groupsTable = {
                title: 'labels.SUPERGROUPGROUPS',
                fields: [{
                  available: true,
                  name: 'name',
                  hasLink: true
                },{
                  available: true,
                  name: 'supergroupLineName',
                  label: 'line'
                }],
                link: {
                  action: 'view',
                  type: 'group',
                  filter: 'id'
                }
              }

              $scope.linesTable = {
                title: 'labels.SUPERGROUPLINES',
                fields: [{
                  available: true,
                  name: 'name'
                }],
              }

              $scope.addLineForm = {
                title: 'labels.SUPERGROUPADDLINE',
                status: '',
                type: 'supergroup',
                model: $scope.model,
                fields: [{
                  available: true,
                  type: 'text',
                  name: 'line',
                  required: true
                }, {
                  available: true,
                  type: 'submit',
                  name: 'empty',
                  value: 'fields.SUBMIT'
                }],
                validate: function () {
                  var errors = [];



                  if (errors.length) {
                    var errorMessages = "<ul>";
                    for (var i = 0; i < errors.length; i++) {
                      var e = errors[i];
                      errorMessages += "<li>" +
                        $filter('translate')('labels.VALIDATIONERROR' + e.error.toUpperCase(), {
                          name: $filter('translate')('fields.' + e.field.name.toUpperCase())
                        }) +
                        "</li>";
                    }
                    errorMessages += "</ul>";
                    $scope.pop('error', $filter('translate')('labels.NOTVALIDFORM'), errorMessages);
                    return false;
                  } else return true;
                },
                submit: function () {
                  if (this.validate()) {
                    $scope.addLineForm.status = 'submitting';
                    $scope.model.action = 'AddSuperGroupLine';
                    D.save($scope.type, $scope.model).then(
                      function (response) {
                        $scope.addLineForm.status = 'submitted';
                        $scope.model = response;
                        $scope.model.action = '';
                        $scope.model.line = '';
                      }
                      
                    ).catch(function (response) {
                        $scope.addLineForm.status = 'error';
                        $scope.model.action = '';
                      });
                  }
                }
              }
            }).catch(console.error)

            D.query('account', '_withGroup=true&supergroup=' + $scope.id).then(function (response) {
              response = response.map(function(u){ u.groupName = u.group.name; return u;})
              $scope.users = response;

              $scope.usersTable = {
                title: 'labels.SUPERGROUPUSERS',
                fields: [{
                  available: true,
                  name: 'name',
                  hasLink: true
                },{
                  available: true,
                  name: 'groupName'
                }],
                link: {
                  action: 'view',
                  type: 'user',
                  filter: 'id'
                }
              }
            }).catch(console.error)

          }).catch(console.error)


        } else {
          if (!$scope.watchActivated) {
            $scope.watchActivated = true;
            $rootScope.$watch('user.id', function () {
              if (!$scope.initialized) {
                $scope.init();
              }
            });
          }
        }
      }

      $scope.init();
    }
  ]);